import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_bhls55b60v: FaireBrandEntity = {
  token: "b_bhls55b60v",
  type: "brand",
  name: "Sol and Selene",
  avatarUrl: "https://cdn.faire.com/fastly/1a9d1a135c15f95894f9bbadaccc02c531fb9708a3f0152bcbe1b6b761574a83.jpeg",
  bannerUrl: "https://cdn.faire.com/fastly/6c5591901764d4bd2257aac1f77533d1d90f5e5f9f1d9927de5d17e9a54bf031.jpeg",
  logoUrl: "https://cdn.faire.com/fastly/1a9d1a135c15f95894f9bbadaccc02c531fb9708a3f0152bcbe1b6b761574a83.jpeg",
  heroImageUrl: "https://cdn.faire.com/fastly/6c5591901764d4bd2257aac1f77533d1d90f5e5f9f1d9927de5d17e9a54bf031.jpeg",
  location: "Los Angeles, CA, USA",
  minimumOrderDollars: 150,
  rating: 4.9,
  reviewCount: 287,
  isTopShop: true,
  isInsider: true,
  description: "The meaning of Sol and Selene is sun and moon in Roman and Greek mythology. Sol is the Roman sun god and Selene is the Greek moon goddess. Together they represent the divine balance of light and dark. In our journey, the sun and moon support us in our growth and connect us with our loving purpose.\n\nWe don't believe in finish lines - like you, we work overtime to up the ante, breaking boundaries with every design.  Our bags are constructed to complement your day to night lifestyle while you're out there on your grind, making it happen.\n\nOur products are constructed of long-lasting durable material, lightweight and water repellant.  Designed to cross over from each activity in your life.  We pride ourselves in our multi-functional capabilities keeping you taken care of from AM to PM.",
  meta: {
    source: "api",
    importedAt: "2026-10-07T18:32:28.954Z",
    importedBy: "entity-db-cli"
  }
};
